import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'load' })
export class AtxLoadPipe implements PipeTransform {
    transform(element: any, search: string): string {
        return this.recursiveSearch(element, search.split('.').reverse());
    }

    private recursiveSearch(element, key): string {
        if (element) {
            const value = element[key[0]];

            return (!value) ? this.recursiveSearch(element[key.pop()], key) : value
        }

        return;
    }
}
